import React, { useState, useEffect, useContext } from "react";
import Nearby from "./component/Nearby";
import RecommendedProfile from "./component/RecommendedProfile";
import UnlockedProfiles from "./component/UnlockedProfiles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApplicantsDetails from "../Vaccancy/ApplicantsDetails";
// import Location from "./component/Location";
import { useTranslation } from "react-i18next";

// import axios from "axios";
import {
   // ALL_CATEGORIES,
   // baseUrl,
   CANDIDATE_NEAR_ME,
   Categories_Count,
   // Count_Seekers,
   // job_category_url,
   LOCATION,
   RECOMMENDED_CANDIDATES,
   Recruiter_Profile_Status,
   UNLOCKED_PROFILES,
} from "../../Service/service";
import { getData, patchData, postData } from "../../Service/ApiMethod";
import ReactSpeedometer from "react-d3-speedometer";
// import EditProfile from "../Profiles/EditProfile";
// import { candata } from "../../App"; 
import Loader from "../login/Loader";
import { useRef } from "react";
import { lang } from "../../lang";

const Home = () => {
   const [ln,setLn] = useState('en')
   const [popup, setPopup] = useState(false);
   // const [location, setLocation] = useState(false);
   // const [latitude, setLatitude] = useState();
   // const [longitude, setLongitude] = useState();
   const [profileData, setProfileData] = useState();
   const [categoriesCount, setCategoriesCount] = useState();
   const [categoriesCountErr, setCategoriesCountErr] = useState();
   // const [updateProfilePopup, setUpdateProfilePopup] = useState(false)
   // const [recommendedCandidatesData, setRecommendedCandidatesData] = useState()
   const [unlockedData, setUnlockedData] = useState()
   // const [lat, setLat] = useState();
   // const [lng, setLng] = useState();
   // const [status, setStatus] = useState(null);
   const [loaderStart, setLoaderstart] = useState(false)
   // JobCategories
   // const { newData, setNewData } = useContext(candata);
   // const [JobCategories, setJobCategories] = useState();
   const [recommendedCandidates, setRecommendedCandidates] = useState();
   const [isError, setIsError] = useState();
   const [showMore, setShowMore] = useState({
      jobCategoryBox: 9,
      title: "Show More",
   });
   // const fetchJobCat = async () => {
   //   try {
   //     const res = await axios.get(baseUrl + job_category_url);
   //     console.log(res?.data?.data);
   //     setJobCategories(res.data);
   //   } catch (err) {
   //     console.log(" code Error", err);
   //     setIsError(err.message);
   //     console.log(isError);
   //   }
   // };
   // Profile Status
   const [profileStatus, setProfileStatus] = useState();
   const [profileStatusPercentage, setProfileStatusPercentage] = useState();
   // const p = 0;
   const [profileStatusErr, setProfileStatusErr] = useState();
   const navigate = useNavigate();
   // const CurrentLocation = useLocation(lat, lng)
   const isSub = useRef()
   const profile_Status = () => {
      getData(Recruiter_Profile_Status)
         .then((response) => response.json())
         .then((res) => {
            setLoaderstart(false)
            console.log("okkkkkkkk000000", res?.data);
            isSub.current = res?.data?.is_subscribed
            let lat = res?.data?.latitude
            let long = res?.data?.longitude
            if (res?.data?.is_subscribed == false) {
               cateGroup(lat, long)
            }
            setProfileStatusPercentage(res?.data?.recruiter_profile);
            let percentage = res?.data?.recruiter_profile;
            let value = percentage?.replace("%", "");
            let fvalue = +value;
            setProfileStatus(fvalue);
            setProfileStatusPercentage(percentage);
            setProfileData(res.data)
            console.log("profile Data", res?.data);
            console.log("profile completion status", res?.data?.recruiter_profile);
            console.log("fvalue", fvalue);
         })
         .catch((err) => {
            setProfileStatusErr(err.message);
            setLoaderstart(false)
            console.log("profileStatusErr", profileStatusErr);
         });
   };
   console.log('ProfileData', profileData)
   const MyLocation = () => {
      const obj = {
         "latitude": localStorage.getItem('lat'),
         "longitude": localStorage.getItem('lng')
      }
      patchData(obj, LOCATION)
         .then((resp) => resp.json())
         .then((data) => {
            console.log('locationnnnnnnnnnnn', data?.data)
         }
         )
   }
   useEffect(() => {
      setLoaderstart(true)
      MyLocation()
   }, [])
   const postCandidateNearMe = () => {
      const obj = {
         radius: 1500,
      }
      postData(obj, CANDIDATE_NEAR_ME)
         .then((response) => response.json())
         .then((data) =>
            navigate("/recommended-profiles", { state: { data: data, title:"Candidates Near Me", distance: '1500' } }))
         .catch((err) => {
            console.log('Error', err);
         })
   }
   const recomendedcandidateListData = () => {
      navigate("/recommended-profiles", { state: { data: recommendedCandidates, title: lang && Object.keys(lang).length > 0 ? lang[ln]?.Home['Recommended Candidates']:"" }})
   }
   const handleCategoriesCount = () => {
      getData(Categories_Count)
         .then((response) => response.json())
         .then((data) => {
            setCategoriesCount(data.data);
            console.log('Categories_Count', data.data)
         })
         .catch((err) => {
            setCategoriesCountErr('Something Went Wrong');
            console.log('err.message', err.message);
         });
   };
   console.log('isError', isError);
   const getRecommendedCandidates = () => {
      getData(RECOMMENDED_CANDIDATES)
         .then((response) => response.json())
         .then((data) => {
            console.log("recruiter/RecommendedCandidate/00000", data);
            setRecommendedCandidates(data.data);
         })
         .catch((err) => {
            console.log("Error in categories from Post Form", err);
            console.log(" code Error", err);
            setIsError(err.message);
            console.log(isError);
         });
   };
   console.log('recommended Candidates home', recommendedCandidates)
   console.log('profileStatusPercentage', profileStatusPercentage)
   const getUnlockedProfileData = () => {
      getData(UNLOCKED_PROFILES)
         .then((response) => response.json())
         .then((res) => {
            setUnlockedData(res.data)
            console.log(' UnlockedData', res.data)
         })
         .catch((err) => {
            console.log('Error in categories from Post Form', err);
            console.log(' code Error', err);
         })
   }
   const bar = document.getElementById("bar");
   useEffect(() => {
      if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
      getRecommendedCandidates();
      profile_Status();
      handleCategoriesCount()
      getUnlockedProfileData()
   }, [])
   const setProgress = (percent) => {
      profile_Status();
      if (percent == undefined) {
         percent = profileStatus;
      }
      if (bar) {
         const p = 180 - (percent / 100) * 180;
         bar.style.transform = `rotate(-${p}deg)`;
      }
   };
   useEffect(() => {
      setProgress(profileStatus);
   }, [bar]);
   useEffect(() => {
      setProgress(profileStatus);
   }, [profileStatus]);
   console.log(profileData?.subscription_plan, "plan")
   const [listView, setListview] = useState([])
   const List = useRef([])
   const cateGroup = async (currentLatitude, currentLongitude) => {
      var request = {
         radius: 200,
         "latitude": currentLatitude,
         "longitude": currentLongitude
      };
      console.log(request, "dxxxxxxxxx");
      fetch("https://api.catzapp.com/recruiter/countseekers_by_category/", {
         method: "POST",
         headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
         },
         body: JSON.stringify(request),
      })
         .then((response) => response.json())
         .then((res) => {
            console.log('res~~~~~~2222', res.data);
            let total = 0
            res.data.map((it) => {
               total = it.rec_cnt + total
            })
            setListview(res.data)
            List.current = res.data
            console.log(total, "let check valu")
         })
         .catch(error => { });
   }
   const { t } = useTranslation();

   const MVacancies =(item)=>{
      navigate("/vaccancy", { state: { data: item?.category_name} }) 
   }


   return (
      <>
         {
            loaderStart == true ? (
               <Loader />
            ) : null
         }
         <div>
            <div className="row">
               <div className="col-md-12">
                  {categoriesCount?.length > 0 && 
                     <h1 className="heading mt-3">{lang && Object.keys(lang).length > 0 ? lang[ln]?.Home['Job Categories']:""}</h1>
                  }
               </div>
            </div>
            {/* {console.log(JobCategories, "cpoll")} */}
            {console.log(categoriesCount, "cpoll")}
            {/* {
   categoriesCount?.length <=2
   }  */}
            <div
               className="row space-evenly"
            >
               {categoriesCountErr != null ? (
                  <>
                     <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className="categories-box">
                           <div className="category-img">
                              <img
                                 src="./images/err.jpg"
                                 alt="img"
                                 className="category-img"
                                 style={{}}
                              />
                           </div>
                           <h3 className="category-title text-danger">{categoriesCountErr}</h3>
                           {/* 
            <p className="numberOfCandidate text-warning">(Error code)</p>
            */}
                        </div>
                     </div>
                  </>
               ) : categoriesCount !== undefined ? (
                  categoriesCount?.map((item, index) => {
                     if (categoriesCountErr) {
                        console.log("not equal 200");
                        return (
                           <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center " key={index}>
                              <div className="categories-box">
                                 <div className="category-img">
                                    <img
                                       src={item?.category_image}
                                       alt="img"
                                       className="category-img"
                                    />
                                 </div>
                                 <h3 className="category-title">{categoriesCountErr}</h3>
                                 <p className="numberOfCandidate">(Error code)</p>
                              </div>
                           </div>
                        );
                     } else if (index <= showMore?.jobCategoryBox) {
                        return (
                           <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center " key={index} >
                              <div className="categories-box" onClick={() => MVacancies(item)}>
                                 <div className="category-img">
                                    <img
                                       src={item?.category_image || './images/Rectangle-scenery.png'}
                                       alt="img"
                                       className="category-img"
                                       height=''
                                    />
                                 </div>
                                 <h3 className="category-title">{item?.category_name}</h3>
                                 {/* 
         <p className="numberOfCandidate">(200 Candidates)</p>
         */}
                                 <p className="numberOfCandidate">({item?.count} {item?.count > 1 ? `${t('Candidates')}` : `${t('Candidate')}`}) </p>
                              </div>
                           </div>
                        );
                     }
                  })
               ) : null}
            </div>
            <div className="flex-center mt-3">
               {categoriesCount !== undefined ? (
                  categoriesCount?.length >= 10 ? (
                     <>
                        <button
                           className="link btn-none view-all"
                           onClick={() => {
                              setShowMore({
                                 jobCategoryBox:
                                    showMore?.jobCategoryBox === 9
                                       ? categoriesCount?.length
                                       : 9,
                                 title:
                                    showMore?.title === "Show More"
                                       ? "Show Less"
                                       : "Show All",
                              });
                           }}
                        >
                           {showMore?.title}
                           <span className="transform"> </span>
                        </button>
                     </>
                  ) : null
               ) : null}
               {/* -----------------categoriesCount end-----------------  */}
               {/* <button className="link btn-none view-all" onClick={()=>setJobCategoryBox(jobCategoryBox == 8 ? JobCategories?.data.length : 8)}>Show More <span className="transform"> > </span> </button> */}
            </div>
            {/* Subscription */}
            {!(profileData?.user?.user_types == 'sub_user') ? ((profileData?.subscription_plan == "FREE") ?
               <>
                  <div className="flex-center mt-3 subcription-section" style={{ width: '100%' }}>
                     <div className="subcription-box" style={{ width: '100%' }}>
                        <div className="row">
                           <div className="col-8 px-0">
                              <h3 className="sub-heading mb-2">{t('Your Subscription Info')}</h3>
                              <p className="text mb-3">
                                 {t('Upgrade your subscription to fulfill your requirements with our best plans')}.
                              </p>
                              <div
                                 className="theme-btn-link mt-3"
                                 onClick={() => {
                                    setPopup(true);
                                    navigate('/subcription')
                                 }}
                                 style={{ display: 'inline-block' }}
                              >
                                 {t('Upgrade your Subscription')}
                              </div>
                           </div>
                           <div className="col-4 px-0 flex-center">
                              <img src="../images/upgrade-subcription.png" alt="" />
                           </div>
                        </div>
                     </div>
                  </div>
               </>
               : "") : ""
            }
            {/* Subscription */}
            {/* Recommended Profiles  section */}
            {recommendedCandidates?.length != 0 || List.current.length != 0 ? (<>
               <div className="row  mt-3">
                  <div className="col-md-12 d-flex space-between align-items-center">
                     <h1 className="heading">{t('Recommended Candidates')}</h1>
                     {
                        isSub.current == false ? null : (
                           <p onClick={() => recomendedcandidateListData()} className="view-all" style={{ cursor: 'pointer' }}>
                              {t('View All')}
                           </p>
                        )
                     }
                  </div>
               </div>
               {isSub.current == false ? List.current.length != 0 ? (
                  <div className="mt-3 row">
                     {
                        List.current?.map((item, index) => (
                           <div
                              className="col-lg-4 col-md-4 col-sm-6 col-12"
                              onClick={() => {
                                 navigate('/subcription')
                              }}
                           >
                              <div className="recommended-profile"
                              >
                                 <div className="row" style={{ alignItems: 'center' }}>
                                    <div className="  relative flex-center">
                                       <div className="profile-img-box">
                                          <img src={item?.category_icon || "../images/Vector.png"} alt="" className="profile-img" style={{}} />
                                       </div>
                                    </div>
                                    <div className="d-flex justify-content-center flex-column align-items-center">
                                       <h2 className="card-heding" style={{ cursor: "pointer" }}>
                                          {item?.category_name}
                                       </h2>
                                       <p className="designation text-center">{item?.rec_cnt} {item?.rec_cnt == 1 ? lang && Object.keys(lang).length > 0 ? lang[ln]?.JobCategoriesdata["Candidate"]:"" : lang && Object.keys(lang).length > 0 ? lang[ln]?.JobCategoriesdata["Candidates"]:""} </p>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                       <img className="padlockimg" src="../images/padlock.png" alt="" style={{}} />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        ))
                     }
                  </div>
               ) : (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: "100px" }}>{t('No Data Found')}</div>) : (
                  <div className="row mt-3">
                     <RecommendedProfile data={recommendedCandidates} />
                  </div>
               )}
            </>) : null
            }
            {
               profileStatusPercentage != '100' &&
               <div className="mt-3 flex-center complete-profile-section">
                  <div
                     className="profile-completion-box flex-center"
                     style={{
                        flexDirection: "column",
                        position: 'unset',
                        zIndex: ' 1'
                     }}
                  >
                     <div className="completion-graph relative w-100">
                        {/*<img src="./images/profile-graph.png" alt="" />
      <img
         src="./images/graph-arrow.png"
         alt=""
         className="graph-arrow"
         />*/}
                        <div className="wrapper w-100 flex-center" >
                           <div className="circle-out" >
                              <div id="bar" class="circle" style={{ position: 'absolute', zIndex: "0" }}>
                              </div>
                              {/* <span className="text">{profileStatus + "%"}</span> */}
                           </div>
                        </div>
                        <ReactSpeedometer
                           value={profileStatusPercentage}
                           minValue={0}
                           maxValue={100}
                           startColor="#218D18"
                           endColor="#218D18"
                           height={200}
                           textColor="#fff"
                           segments={1}
                           style={{ position: "unset", zIndex: "0", textColor: "redp" }}
                        />
                        <div
                           style={{
                              display: "flex",
                              justifyContent: "center",
                              fontSize: "1.5em",
                           }}
                        >
                           {profileStatusPercentage == undefined ? 0:profileStatusPercentage + "%" ?? "API error"}
                        </div>
                     </div>
                     <h2 className="profile-heading">
                        {t('Complete Your Profile')}
                     </h2>
                     <div className="about-profile">
                        {t('Your profile is incomplete! Please complete your profile to find the right candidate for your job')}. {" "}
                     </div>
                     {profileStatusPercentage == "100%" ? (
                        ""
                     ) : (
                        // 
                        //<Link to="/MainProfile" className="theme-btn-link mt-3">
                        //   Complete Now
                        // </Link>
                        <a
                           className="theme-btn-link mt-3"
                           onClick={() => {
                              navigate("/MainProfile");
                              // setUpdateProfilePopup(true)
                           }}
                        >
                           {t('Complete Now')}
                        </a>
                     )}
                     {/* {updateProfilePopup && 
<EditProfile setUpdateProfilePopup={setUpdateProfilePopup} profileData={profileData} />
} */}
                  </div>
               </div>
            }
            {unlockedData?.length > 0 &&
               <>
                  <div className="d-flex space-between align-items-center mt-3 px-3">
                     <h1 className="heading">{t('Unlocked Candidates')}</h1>
                     <Link to="/unlock-profiles" className="view-all">
                        {t('All Profiles')}
                     </Link>
                  </div>
                  <div className="row mt-3">
                     <UnlockedProfiles />
                  </div>
               </>
            }
            {/* -----------------Candidates Near Me section---------------- */}
            <div className="row mt-3 ">
               <div className="col-md-12 d-flex space-between align-items-center">
                  <h1 className="heading">{t('Candidates Near Me')}</h1>
                  {/* 
      <p className="text">
         Lorem ipsum dolor sit amet, consectadipi sed do eiusm
      </p>
      */}

                  {
                     isSub.current == false ? null : (<button
                        className="view-all btn-none"
                        onClick={() => {
                           // setLocation(!location);
                           postCandidateNearMe()
                        }}
                        style={{ cursor: 'pointer' }}
                     >
                        {t('View All')}
                     </button>)
                  }
               </div>
            </div>
            {/* {location ? (
// <Location
//   closePopup={() => {
//     setLocation(!location);
//   }}
//   crossClose={() => {
//     setLocation(!location);
//   }}
// />
) : null} */}
            <div className="mt-3 row">
               <Nearby />
            </div>
            {popup ? (
               <ApplicantsDetails
                  closePopup={() => {
                     setPopup(false);
                  }}
               />
            ) : null}
         </div>
         {/* <div style={{ height: "72px" }} /> */}
         {/* 
<Footer/>
*/}
      </>
   );
};
export default Home;
